import { SvgIcon } from '@mui/material';
import { FC } from 'react';

const IberiaDark: FC = () => (
  <SvgIcon fontSize="inherit">
    <svg fill="none" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient
          id="linearGradient-1"
          x1="99.034"
          x2="136.49"
          y1="15.507"
          y2="52.394"
          gradientTransform="scale(1.2865 .77728)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED7417" offset="0" />
          <stop stopColor="#FACD08" offset=".85" />
          <stop stopColor="#FACD08" offset="1" />
        </linearGradient>
      </defs>
      <g transform="matrix(.11885 0 0 .11885 -3.3883 -3.24)" fill="none">
        <g id="logo_iberia" transform="matrix(3.8748 0 0 3.8748 -466.91 47.42)" fillRule="evenodd">
          <path
            transform="matrix(1,0,0,-1,0,51)"
            // eslint-disable-next-line max-len
            d="m137.29 20.848-9.2879-9.8469v-0.001303c32.24 0 39.841 7.9614 44.276 18.799l3.7241 10.201c-10.862-0.32836-27.253-7.0532-38.712-19.152"
            fill="url(#linearGradient-1)"
          />
          <path
            transform="matrix(1,0,0,-1,0,17)"
            // eslint-disable-next-line max-len
            d="m160.45 9.5699-9.448-9.5699c8.9702 6.4431 17.916 10.33 26.828 11.334l2.1724 5.6659c-13.193 0-14.99-2.8845-19.552-7.4301"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export default IberiaDark;
